// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, WithClass } from "./Dom";
import { VisibilityChangedEvent } from "./Event";
import { ValueTextRenderer } from "./Value.TextFormat.Renderer";
import { Form } from "./WebSite.Form";
import { ComponentWithClass, ComponentWithName, WebPageComponent } from "./WebSite.Page.Component";

function FieldCondition(field, value) {
  this.isMet = function () {
    var renderer = new ValueTextRenderer();
    return renderer.render(this.field.getValue()) === this.value;
  }

  this.field = field;
  this.value = value;
}

export class ConditionalComponent extends WebPageComponent {
  constructor(element) {
    super(element);

    this.value = "";
    this.hideSelf = this.element.dataset.HideSelf === "true";
  }

  determineElements() {
    const form = this.getAncestor(new ComponentWithClass(Form));
    const conditionElements = new DomQuery(this.element).getChildren(WithClass("FieldCondition"));

    this.conditions = new Array();

    for (const condition of conditionElements) {
      const fieldName = condition.dataset.Name;
      const component = form.getDescendant(new ComponentWithName(fieldName));

      if (component !== null)
        this.conditions.push(new FieldCondition(component, condition.dataset.Value));
      else
        console.log("Cannot find field for element: " + fieldName);
    }
  }

  bind() {
    this.determineElements();
    this.attachEventHandlers();
    this.updateVisibility();
  }

  valueChanged() {
    this.updateVisibility();
  }

  updateVisibility() {
    let visible = false;
    let index = 0;

    while (!visible && index < this.conditions.length) {
      visible = this.conditions[index].isMet();
      index++;
    }

    this.visible = visible;
    this.element.classList.toggle("Hidden", !this.visible);

    if (!this.hideSelf) {
      const parent = this.parentComponent;

      if (parent !== null)
        parent.handleEvent(new VisibilityChangedEvent(this));
    }
  }

  attachEventHandlers() {
    const fields = new Array(this.conditions.length);

    for (let index = 0; index < this.conditions.length; index++) {
      const condition = this.conditions[index];

      if (fields.indexOf(condition.field) == -1)
        condition.field.addEventListener("change", (event) => { this.valueChanged(); });

      fields[index] = condition.field;
    }
  }
}

interactivityRegistration.register("ConditionalComponent", function (element) { return new ConditionalComponent(element); });
